import { useState, useEffect } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";

const LITIGATION_FIELDS = [
  { key: "screen_by_stage", label: "Case Stage" },
  { key: "screen_by_status", label: "Case Status" },
  { key: "has_issues", label: "Has Issues" },
  { key: "is_flagged", label: "Is Flagged" },
  { key: "court_name", label: "Court Name" },
  { key: "trial_date", label: "Trial Date" },
  { key: "filing_date", label: "Filing Date" },
];

const LitigationReportValueModal = ({
  show,
  handleClose,
  currentValues,
  currentScreenBy,
  onSave,
  caseStages = [],
  caseStatuses = [],
}) => {
  const [formValues, setFormValues] = useState({
    screen_by_stage: false,
    screen_by_status: false,
    has_issues: false,
    is_flagged: false,
    court_name: false,
    trial_date: false,
    filing_date: false,
  });

  const [screenBy, setScreenBy] = useState({
    case_stage: "",
    case_status: "",

    marked_for_litigation: false,
    pending_deposition: false,
    outstanding_discovery: false,
    not_served: false,
  });

  useEffect(() => {
    if (currentValues) {
      setFormValues(currentValues);
    }
    if (currentScreenBy) {
      setScreenBy(currentScreenBy);
    }
  }, [currentValues, currentScreenBy, show]);

  const toggleField = (fieldKey) => {
    setFormValues((f) => ({ ...f, [fieldKey]: !f[fieldKey] }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    LITIGATION_FIELDS.forEach((field) => {
      allSelected[field.key] = true;
    });
    setFormValues(allSelected);
  };

  const handleClearAll = () => {
    const allCleared = {};
    LITIGATION_FIELDS.forEach((field) => {
      allCleared[field.key] = false;
    });
    setFormValues(allCleared);
  };

  const handleApply = () => {
    onSave({
      values: formValues,
      screenBy: screenBy,
    });
  };

  const selectedCount = Object.values(formValues).filter(Boolean).length;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="md"
    >
      <div style={{ minHeight: "200px" }}>
        <Modal.Header
          style={{ borderBottom: "0px" }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Litigation Report Values ({selectedCount} selected)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0 m-t-5 m-l-5 m-r-5 m-b-5" style={{ minHeight: "max-content" }}>
          <div className="custom-tab">
            {/* Screen By Section */}
            <Row className="mx-0 pe-0 m-b-10">
              <Col md={12} className="p-0">
                <div
                  className="m-b-5"
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "var(--primary)",
                  }}
                >
                  Screen By:
                </div>

                {/* Case Stage Dropdown */}
                <div className="row mx-0 align-items-center m-b-5">
                  <div className="col-md-12 p-0">
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "var(--primary-80)",
                        marginBottom: "3px",
                      }}
                    >
                      Case Stage
                    </label>
                    <select
                      className="form-control height-25 p-0 p-l-5 rounded-0"
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: screenBy.case_stage ? "black" : "var(--primary-25)",
                      }}
                      value={screenBy.case_stage}
                      onChange={(e) => setScreenBy({ ...screenBy, case_stage: e.target.value })}
                    >
                      {caseStages.map((stage) => (
                        <option key={stage.id} value={stage.id}>
                          {stage.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Case Status Dropdown */}
                <div className="row mx-0 align-items-center m-b-5">
                  <div className="col-md-12 p-0">
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "var(--primary-80)",
                        marginBottom: "3px",
                      }}
                    >
                      Case Status
                    </label>
                    <select
                      className="form-control height-25 p-0 p-l-5 rounded-0"
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: screenBy.case_status ? "black" : "var(--primary-25)",
                      }}
                      value={screenBy.case_status}
                      onChange={(e) => setScreenBy({ ...screenBy, case_status: e.target.value })}
                    >
                      {caseStatuses.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row mx-0 align-items-center m-b-5">
                  <div className="col-md-6 p-l-0 p-r-5">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.marked_for_litigation}
                        onChange={(e) =>
                          setScreenBy({ ...screenBy, marked_for_litigation: e.target.checked })
                        }
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Marked For Litigation
                    </label>
                  </div>

                  <div className="col-md-6 p-l-0 pe-0">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.pending_deposition}
                        onChange={(e) =>
                          setScreenBy({ ...screenBy, pending_deposition: e.target.checked })
                        }
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Pending Deposition
                    </label>
                  </div>
                </div>

                <div className="row mx-0 align-items-center">
                  <div className="col-md-6 p-l-0 p-r-5">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.outstanding_discovery}
                        onChange={(e) =>
                          setScreenBy({ ...screenBy, outstanding_discovery: e.target.checked })
                        }
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Outstanding Discovery
                    </label>
                  </div>

                  <div className="col-md-6 p-l-0 pe-0">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.not_served}
                        onChange={(e) => setScreenBy({ ...screenBy, not_served: e.target.checked })}
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Not Served
                    </label>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Report Values Section */}
            <Row className="mx-0 pe-0 m-t-10">
              <Col md={12} className="p-0">
                <div
                  className="m-b-5"
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "var(--primary)",
                  }}
                >
                  Report Values:
                </div>

                <div
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  <div className="d-flex flex-wrap mx-0 pe-0">
                    {LITIGATION_FIELDS.map((field) => (
                      <div
                        key={field.key}
                        className="col-md-6 p-l-0"
                        style={{
                          paddingRight: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        <label
                          className="d-flex align-items-center"
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "600",
                            margin: 0,
                            padding: "0px 5px",
                            background: formValues[field.key] ? "var(--primary-10)" : "transparent",
                            borderRadius: "4px",
                            transition: "all 0.15s",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={formValues[field.key]}
                            onChange={() => toggleField(field.key)}
                            style={{
                              marginRight: "5px",
                              width: "13px",
                              height: "13px",
                              cursor: "pointer",
                            }}
                          />
                          {field.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <div className="d-flex align-items-center" style={{ gap: "5px" }}>
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
              variant="primary"
              onClick={handleClearAll}
            >
              Clear All
            </Button>
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
              variant="primary"
              onClick={handleSelectAll}
            >
              Select All
            </Button>
          </div>
          <Button
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            onClick={handleApply}
          >
            Apply Selection
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default LitigationReportValueModal;
